import React, { useState, useEffect, useRef } from 'react';
import { mockData } from '../mockData';

const ImageCarousel = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const { carousel } = mockData;

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => 
        prevIndex === carousel.length - 1 ? 0 : prevIndex + 1
      );
    }, 4000);

    return () => clearInterval(interval);
  }, [carousel.length]);

const thumbnailRef = useRef(null);


  const goToSlide = (index) => {
  setCurrentIndex(index);

  if (thumbnailRef.current) {
    const thumbnail = thumbnailRef.current.children[index];
    thumbnail.scrollIntoView({
      behavior: 'smooth',
      inline: 'center', // scroll horizontally to center
      block: 'nearest',
    });
  }
};


  return (
    <section className="py-20 bg-gradient-to-br from-slate-50 to-blue-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-[#204080] mb-4 font-serif">
            Our Premium Facilities
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            State-of-the-art equipment and serene environments designed for your optimal healing journey
          </p>
        </div>

        <div className="relative max-w-6xl mx-auto">
          {/* Main Carousel */}
          <div className="relative h-96 md:h-[500px] rounded-3xl overflow-hidden shadow-2xl">
            {carousel.map((item, index) => (
              <div
                key={item.id}
                className={`absolute inset-0 transition-all duration-700 ease-in-out ${
                  index === currentIndex ? 'opacity-100 scale-100' : 'opacity-0 scale-105'
                }`}
              >
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover"
                />
<div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent" />

                <div className="absolute bottom-0 left-0 right-0 p-8 text-white">
                  <h3 className="text-3xl font-bold mb-2">{item.title}</h3>
                  <p className="text-xl text-blue-100">{item.description}</p>
                </div>
              </div>
            ))}
          </div>

          {/* Navigation Dots */}
<div className="flex justify-center mt-8 space-x-3">
  {carousel.map((_, index) => (
    <button
      key={index}
      onClick={() => goToSlide(index)}
                className={`w-4 h-4 rounded-full transition-all duration-300 ${
        index === currentIndex
                    ? 'bg-blue-600 scale-125 shadow-lg'
                    : 'bg-blue-200 hover:bg-blue-400'
      }`}
      aria-label={`Go to slide ${index + 1}`}
    />
  ))}
</div>



          {/* Thumbnail Navigation */}
          <div
  ref={thumbnailRef}
  className="flex overflow-x-auto space-x-4 mt-8 px-4 sm:justify-center max-w-full scrollbar-thin-horizontal"
>

           {carousel.map((item, index) => (
  <button
    key={item.id}
    onClick={() => goToSlide(index)}
    className={`relative flex-shrink-0 w-16 h-16 sm:w-20 sm:h-20 rounded-xl overflow-hidden transition-all duration-300 ${
      index === currentIndex
        ? 'ring-4 ring-blue-500 scale-110'
        : 'hover:scale-105 opacity-70 hover:opacity-100'
    }`}
  >
    <img
      src={item.image}
      alt={item.title}
      className="w-full h-full object-cover"
    />
  </button>

            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ImageCarousel;